import React from 'react';
import Navbar from '../Navbar';
import Footer from '../Pages/Footer';
import SEO from '../components/SEO';
import { useSiteConfig } from '../contexts/SiteConfigContext';

export default function Apropos() {
  const { config } = useSiteConfig();
  const about = config.about;

  return (
    <div>
      <SEO
        title="À propos — Notre agence immobilière"
        description={`${about.slogan ? about.slogan + " — " : ""}${about.text?.slice(0, 140)}`}
        canonical="/about"
      />
      <Navbar />
      <div className="description--enterprise">
        <div className="description--enterprise--content--left">
          <h1 className="name--enterprise">{about.title}</h1>
          {about.slogan && (
            <p style={{ fontStyle: "italic", color: "#1B4F9E", fontWeight: 600, marginBottom: "1rem" }}>
              « {about.slogan} »
            </p>
          )}
          <p>{about.text}</p>
          {about.founded && (
            <p style={{ marginTop: "1rem" }}>
              <strong>Fondée en :</strong> {about.founded}
            </p>
          )}
          {about.address && (
            <p>
              <strong>Siège :</strong> {about.address}
            </p>
          )}
          <p style={{ marginTop: "1.5rem" }}>
            À <strong>SCI MAYEDO</strong>, la gestion locative et la vente de vos biens sont nos priorités. En nous confiant votre bien, vous bénéficierez de notre expertise pour :
          </p>
          <ul>
            <li>Gagner du temps en nous laissant assurer la gestion courante avec rigueur et réactivité.</li>
            <li>Assurer la rentabilité de votre bien dont la valeur commerciale sera optimisée.</li>
            <li>Recouvrer (par voie amiable ou contentieuse) les éventuels impayés de loyers.</li>
            <li>Suivi de la sécurité, conciergerie, nettoyage et entretien des parties communes.</li>
          </ul>
        </div>
        <div className="description--enterprise--content--right">
          <img src="/images/17.jpeg" alt="SCI MAYEDO" />
        </div>
      </div>
      <Footer />
    </div>
  );
}
